import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useUserStore = defineStore('user', () => {
  const user = ref({})

  const fullName = computed(() => `${user.value.first_name} ${user.value.last_name}`)
  const isRole = computed(() => ({
    superAdmin: user.value.roles?.includes('super_admin'),
  }))

  return { user, fullName, isRole }
})
